import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { PlayStoreURL, AppStoreURL, WannaEatBase } from './config/config';

const SmartDeepLinkRedirect = () => {
  const params = useParams();
  const location = useLocation();

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    const isChefPath = location.pathname.startsWith('/chef/');

    if (isChefPath) {
      const parts = location.pathname.split('/');
      const roomId = parts[parts.length - 1];
      window.location.href = `/login?redirect=mychats&roomId=${roomId}`;
      return;
    }

    const { screenName, id } = params;
    let deepLinkPath = screenName || 'Home';
    if (id) {
      deepLinkPath += `/${id}`;
    }

    const appDeepLink = `wannaeat://app/${deepLinkPath}`;
    const fallbackUrl = isAndroid ? PlayStoreURL : (isIOS ? AppStoreURL : WannaEatBase);

    window.location.href = appDeepLink;

    const timer = setTimeout(() => {
      window.location.href = fallbackUrl;
    }, 2500);

    return () => clearTimeout(timer);
  }, [params, location]);

  return (
    <div style={{ textAlign: 'center', marginTop: '100px', fontFamily: 'sans-serif' }}>
      <h2>Opening WannaEat...</h2>
      <p>Please wait while we redirect you.</p>
      <div className="loader" style={{ 
        border: '4px solid #f3f3f3', 
        borderTop: '4px solid #FD207A', 
        borderRadius: '50%', 
        width: '40px', 
        height: '40px', 
        animation: 'spin 2s linear infinite',
        margin: '20px auto'
      }}></div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default SmartDeepLinkRedirect;
